import { BANK_ACCOUNT_OWNERSHIP, createBank, createBankAccount } from '@vezeeta/vpay-pack';

const ENGLISH_LANGUAGE_ID = 1;
const ARABIC_LANGUAGE_ID = 2;
const PERSONAL_ACCOUNT_TYPE = 1;
const COMPANY_ACCOUNT_TYPE = 2;

const CULTURE_FINANCIAL_DETAILS = Object.freeze({
  eg: Object.freeze({ countryCode: 'EG', currency: 'EGP' }),
  sa: Object.freeze({ countryCode: 'SA', currency: 'SAR' }),
});

const getTranslationName = (translations, languageId) =>
  translations?.find(translation => translation?.LanguageId === languageId)?.Name || '';

export const getFinancialDetailsForCulture = culture => {
  const country = culture?.split('-').pop()?.toLowerCase();

  return (
    CULTURE_FINANCIAL_DETAILS[country] || {
      countryCode: country?.toUpperCase() || '',
      currency: '',
    }
  );
};

export const mapBank = bank => {
  const englishName = getTranslationName(bank?.Translations, ENGLISH_LANGUAGE_ID);
  const arabicName = getTranslationName(bank?.Translations, ARABIC_LANGUAGE_ID);

  return createBank({
    id: bank?.BankKey == null ? '' : String(bank.BankKey),
    names: {
      default: englishName || arabicName,
      en: englishName,
      ar: arabicName,
    },
  });
};

export const mapBanks = banks => (Array.isArray(banks) ? banks.map(mapBank) : []);

export const mapBankAccount = bankAccount => {
  if (!bankAccount?.bankKey) {
    return null;
  }

  const bank = createBank({
    id: String(bankAccount.bankKey),
    names: {
      default: bankAccount.bankName || bankAccount.bankNameAR || '',
      en: bankAccount.bankName || '',
      ar: bankAccount.bankNameAR || '',
    },
  });

  return createBankAccount({
    id: bankAccount.bankAccountKey == null ? '' : String(bankAccount.bankAccountKey),
    bank,
    ownershipType:
      Number(bankAccount.accountType) === COMPANY_ACCOUNT_TYPE
        ? BANK_ACCOUNT_OWNERSHIP.COMPANY
        : BANK_ACCOUNT_OWNERSHIP.PERSONAL,
    holderName: {
      first: bankAccount.firstName || '',
      middle: bankAccount.middleName || '',
      last: bankAccount.lastName || '',
      full: bankAccount.fullName || '',
    },
    accountNumber:
      bankAccount.bankAccountNumber == null ? '' : String(bankAccount.bankAccountNumber),
    iban: bankAccount.iban == null ? '' : String(bankAccount.iban),
    swiftCode: bankAccount.swiftCode == null ? '' : String(bankAccount.swiftCode),
    countryCode: bankAccount.countryISOCode || '',
    currency: bankAccount.currency || '',
  });
};

export const mapFinancialInfoAccount = response =>
  mapBankAccount(response?.data?.bankAccounts?.[0]);

export const mapBankAccountPayload = account => ({
  bankAccount: {
    bankKey: account.bank.id,
    bankName: account.bank.names.en || account.bank.names.default,
    bankNameAR: account.bank.names.ar || account.bank.names.default,
    fullName: account.holderName.full,
    firstName: account.holderName.first,
    middleName: account.holderName.middle,
    lastName: account.holderName.last,
    accountType:
      account.ownershipType === BANK_ACCOUNT_OWNERSHIP.COMPANY
        ? COMPANY_ACCOUNT_TYPE
        : PERSONAL_ACCOUNT_TYPE,
    swiftCode: account.swiftCode,
    bankAccountNumber: account.accountNumber,
    iban: account.iban,
    countryISOCode: account.countryCode,
    currency: account.currency,
  },
});
